import {
  PRACTICE_LOCATION_PENDING,
  PRACTICE_LOCATION_SUCCESS,
  PRACTICE_LOCATION_FAIL,
  ADD_PRACTICE_LOCATION_PENDING,
  ADD_PRACTICE_LOCATION_SUCCESS,
  ADD_PRACTICE_LOCATION_FAIL,
  UPDATE_PRACTICE_LOCATION_PENDING,
  UPDATE_PRACTICE_LOCATION_SUCCESS,
  UPDATE_PRACTICE_LOCATION_FAIL,
  PRACTICE_LOCATION_TYPE_PENDING,
  PRACTICE_LOCATION_TYPE_SUCCESS,
  PRACTICE_LOCATION_TYPE_FAIL,
  SET_MESSAGE,
  LOCATION_SUGGESTIONS_SUCCESS,
  LOCATION_SUGGESTIONS_FAIL,
  LOCATION_SUGGESTIONS_PENDING,
  DOWNLOAD_PRACTICE_LOCATION_SUCCESS,
  DOWNLOAD_PRACTICE_LOCATION_PENDING,
  DOWNLOAD_PRACTICE_LOCATION_FAIL,
} from "../types";
import { toast } from "react-toastify";
import UserService from "../../services/user.service";

export const getPracticeLocations = (body) => async (dispatch) => {
  dispatch({
    type: PRACTICE_LOCATION_PENDING,
    payload: { practiceLocations: "isLoading" },
  });
  return await UserService.getPracticeLocations(body)
    .then(
      (data) => {
        data.data.status        
          ? dispatch({
              type: PRACTICE_LOCATION_SUCCESS,
              payload: { practiceLocations: data.data },
            })
          : dispatch({
              type: PRACTICE_LOCATION_FAIL,
            });
        return Promise.resolve();
      },
      (error) => {
        console.log("error......", error);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        dispatch({
          type: PRACTICE_LOCATION_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });

        return Promise.reject();
      }
    )
    .catch((error) => {
      console.log(error);
    });
};
export const getLocationSuggestions = (practiceLocationName ) => async(dispatch) => {
  dispatch({
    type: LOCATION_SUGGESTIONS_PENDING
  });
  
  return await UserService.getLocationSuggestions(practiceLocationName ).then(
    (response) => {
      console.log(response.data,'res');
      
      dispatch({
        type: LOCATION_SUGGESTIONS_SUCCESS,
        payload: { suggestions: response.data.result || [] },
      });
      return Promise.resolve();
    },
    (error) => {
       const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        
      dispatch({
        type: LOCATION_SUGGESTIONS_FAIL,
      });
        
      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });
        
      return Promise.reject();
    }
  ).catch((error) => {
    console.log(error);
  });
};
export const getPracticeLocationTypes = (pageNumber, pageSize, searchQuery) => async (dispatch) => {
  dispatch({
    type: PRACTICE_LOCATION_TYPE_PENDING,
    payload: { practiceLocationTypes: "isLoading" },
  });
  return await UserService.getLocationType(pageNumber, pageSize, searchQuery)
    .then(
      (data) => {
        data.data.status
          ? dispatch({
              type: PRACTICE_LOCATION_TYPE_SUCCESS,
              payload: { practiceLocationTypes: data.data },
            })
          : dispatch({
              type: PRACTICE_LOCATION_TYPE_FAIL,
            });
        return Promise.resolve();
      },
      (error) => {
        console.log("error......", error);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        dispatch({
          type: PRACTICE_LOCATION_TYPE_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });

        return Promise.reject();
      }
    )
    .catch((error) => {
      console.log(error);
    });
};

export const addPracticeLocation = (body) => async (dispatch) => {
  dispatch({
    type: ADD_PRACTICE_LOCATION_PENDING,
    payload: { addPracticeLocation: "isLoading" },
  });
  return await UserService.addPracticeLocation(body)
    .then(
      (data) => {
        console.log(body);
        data.data.status
          ? toast.success("Practice location added Successfully !", {
              autoClose: 2000,
            })
          : toast.error(data.data.message, { autoClose: 2000 });
        data.data.status
          ? dispatch({
              type: ADD_PRACTICE_LOCATION_SUCCESS,
              payload: { addPracticeLocation: data.data.status },
            })
          : dispatch({
              type: ADD_PRACTICE_LOCATION_FAIL,
              payload: { addPracticeLocation: data.data.status },
            });
        return Promise.resolve();
      },
      (error) => {
        console.log("error......", error);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        dispatch({
          type: ADD_PRACTICE_LOCATION_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });

        return Promise.reject();
      }
    )
    .catch((error) => {
      console.log(error);
    }).finally(()=>{
      dispatch({
        type: ADD_PRACTICE_LOCATION_FAIL,
      });
    });
};

//update Practice Location
export const updatePracticeLocations = (body) => async (dispatch) => {
  dispatch({
    type: UPDATE_PRACTICE_LOCATION_PENDING,
    payload: { updatePracticeLocation: "isLoading" },
  });
  return await UserService.updatePracticeLocation(body)
    .then(
      (data) => {
        console.log(body);
        data.data.status
          ? toast.success("Practice location updated Successfully !", {
              autoClose: 2000,
            })
          : toast.error(data.data.message, { autoClose: 2000 });
        data.data.status
          ? dispatch({
              type: UPDATE_PRACTICE_LOCATION_SUCCESS,
              payload: { updatePracticeLocation: data.data.status },
            })
          : dispatch({
              type: UPDATE_PRACTICE_LOCATION_FAIL,
              payload: { updatePracticeLocation: data.data.status },
            });
        return Promise.resolve();
      },
      (error) => {
        console.log("error......", error);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        dispatch({
          type: UPDATE_PRACTICE_LOCATION_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });

        return Promise.reject();
      }
    )
    .catch((error) => {
      console.log(error);
    }).finally(()=>{
      dispatch({
        type: UPDATE_PRACTICE_LOCATION_FAIL,
      });
    });
};

//download practice location

export const downloadPracticeLocation = (body) => async (dispatch) => {
  dispatch({
    type: DOWNLOAD_PRACTICE_LOCATION_PENDING,
    payload: { downloadPracticeLocation: "isLoading" },
  });
  return await UserService.downloadPracticeLocation(body)
    .then(
      (response) => {
        const contentDisposition = response.headers["content-disposition"];
        const filename = contentDisposition
  ? contentDisposition.split("filename=")[1].replace(/['"]/g, "")
  : "PracticeLocation.csv";
        const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success("Practice Location file downloaded successfully!", {
          autoClose: 2000,
        });
        dispatch({
          type: DOWNLOAD_PRACTICE_LOCATION_SUCCESS,
          payload: { downloadPracticeLocation: true },
        });
        return Promise.resolve();
      },
      (error) => {
        console.error("Error downloading Practice Location file:", error);
        const message =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          "Failed to download the Practice Location file.";
        toast.error(message, { autoClose: 2000 });

        dispatch({
          type: DOWNLOAD_PRACTICE_LOCATION_FAIL,
          payload: { downloadPracticeLocation: false },
        });
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
        return Promise.reject();
      }
    )
    .catch((error) => {
      console.error(error);
    });
};

